import { render, staticRenderFns } from "./Firmar.vue?vue&type=template&id=216ba620"
import script from "./Firmar.vue?vue&type=script&lang=js"
export * from "./Firmar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports